'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jQuery = require('jQuery');

var _jQuery2 = _interopRequireDefault(_jQuery);

var _hubspot = require('hubspot.Interframe');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _messageTypes = require('./messageTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var queuedMessages = [];

var FrameEventBus = function () {
  function FrameEventBus() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        logger = _ref.logger;

    _classCallCheck(this, FrameEventBus);

    this.loaded = false;
    this.logger = logger || window.LOG || window.console;

    this.interframe = new _hubspot2.default('*', window.parent, true);
    (0, _jQuery2.default)(this.interframe).on('message', this.handleInterframeMessage.bind(this));

    this.interframe.start();
  }

  _createClass(FrameEventBus, [{
    key: 'log',
    value: function log() {
      var _logger;

      (_logger = this.logger).debug.apply(_logger, arguments);
    }
  }, {
    key: 'handleInterframeMessage',
    value: function handleInterframeMessage(event, _ref2) {
      var type = _ref2.type;

      this.log('message received inner');
      if (!type) {
        return;
      }

      this.log('message received inner', type);

      switch (type) {
        case _messageTypes.SEND_LOADED:
          this.handleLoaded();
          break;
        case _messageTypes.GET_DIMENSIONS:
          this.sendDimensionsMessage();
          break;
        default:
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded() {
      var _this = this;

      if (!this.loaded) {
        this.loaded = true;
        this.log('loaded, sending queued messages', queuedMessages);
        queuedMessages.forEach(function (payload) {
          return _this.sendInterframeMessage(payload);
        });
        queuedMessages = [];
      }
    }
  }, {
    key: 'sendInterframeMessage',
    value: function sendInterframeMessage(payload) {
      if (!this.loaded) {
        queuedMessages.push(payload);
        this.log('queueing message', payload);
        this.log('messages queued', queuedMessages);
        return;
      }

      this.interframe.postMessage(payload);
    }
  }, {
    key: 'sendLoadedMessage',
    value: function sendLoadedMessage() {
      this.sendInterframeMessage({
        type: _messageTypes.SEND_LOADED
      });
    }
  }, {
    key: 'sendDimensionsMessage',
    value: function sendDimensionsMessage(overridenHeight) {
      var pageElement = document.querySelector('.page-signup');

      var height = null;
      if (overridenHeight) {
        height = overridenHeight;
      } else if (pageElement) {
        height = pageElement.clientHeight;
      } else {
        height = window.innerHeight;
      }

      this.sendInterframeMessage({
        type: _messageTypes.SEND_DIMENSIONS,
        payload: {
          height: height
        }
      });
    }
  }, {
    key: 'sendRedirectMessage',
    value: function sendRedirectMessage(redirectUrl) {
      this.sendInterframeMessage({
        type: _messageTypes.SEND_REDIRECT,
        payload: redirectUrl
      });
    }
  }]);

  return FrameEventBus;
}();

exports.default = FrameEventBus;
module.exports = exports['default'];